module.exports = __webpack_public_path__ + "assets/favicons/mstile-70x70.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/mstile-70x70.png
// module id = 2fBL
// module chunks = 1